module.exports = __webpack_public_path__ + "static/media/guiana.b4f0e7b4.jpg";